import { EMPTY_FIELD } from 'constants/emptyField';

import { BankOperationStatusChipField } from 'pages/Finance/BankOperations/components/BankOperationStatusChipField/BankOperationStatusChipField';
import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { BankOperationComment } from 'types/embedded/bankOperation';

import { AvatarWrapperStyled, BoxStyled } from './BankOperationsListComment.styled';
import { BankOperationsListCommentUser } from './BankOperationsListCommentUser/BankOperationsListCommentUser';

export const BankOperationsListComment: React.FC = () => {
  const record = useRecordContext<Partial<BankOperationComment>>();

  if (!record) {
    return <></>;
  }

  return (
    <BoxStyled>
      <AvatarWrapperStyled>
        <RecordContextProvider value={record?.user}>
          <BankOperationsListCommentUser createdAt={record?.createdAt || ''} />
        </RecordContextProvider>
        <RecordContextProvider value={record.status}>
          <BankOperationStatusChipField emptyText={EMPTY_FIELD} source="description" />
        </RecordContextProvider>
      </AvatarWrapperStyled>
      <Box sx={{ overflowX: 'auto' }}>
        <Typography>{record?.commentText}</Typography>
      </Box>
    </BoxStyled>
  );
};
